import { render } from "./RestaurantEdit.vue?vue&type=template&id=61a7c440&scoped=true"
import script from "./RestaurantEdit.vue?vue&type=script&lang=js"
export * from "./RestaurantEdit.vue?vue&type=script&lang=js"

import "./RestaurantEdit.vue?vue&type=style&index=0&id=61a7c440&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a7c440"]])

export default __exports__